import ws from '@api/webservice'
import config from '@app/config'

const api = {
  get: (fileId: string) => ws<FileDetailResponse>(config.ws.files.get.replace('{fileId}', fileId), 'GET'),
}

export default api
